export default "/assets/images/pair-your-mila.png?6caeb213a9eaa1cdc1de1b32fb5c62d5";